import ReactGA from 'react-ga';

const trackingID = process.env.REACT_APP_GOOGLE_ANALYTICS_TRACKING_ID;
export const initGA = () => {
  ReactGA.initialize(trackingID);
};
export const setPageView = page => {
  ReactGA.pageview(page);
};
